import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks';

export default function ArticlesSection() {
  const featuredArticles = hotArticles.filter((a) => a.featured);
  const regularArticles = hotArticles.filter((a) => !a.featured);

  return (
    <section className="py-12 md:py-16 bg-foreground-950">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 mb-8 md:mb-12">
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 rounded-full border border-primary-400/30 text-primary-400 text-xs font-medium">
              实时更新
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
              黑料大瓜全纪录
            </h2>
          </div>
          <Link
            to="/category/jinri-dagua"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {featuredArticles.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
            {featuredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group relative rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200 transition-all"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-md bg-primary-500/10 text-primary-400 text-xs font-medium">
                      {article.category}
                    </span>
                    {article.hot && (
                      <span className="px-2 py-0.5 rounded-md bg-accent-500/10 text-accent-400 text-xs font-medium flex items-center gap-1">
                        <i className="ri-fire-line" /> 热门
                      </span>
                    )}
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" /> {article.views.toLocaleString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {regularArticles.slice(0, 4).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-all"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="px-1.5 py-0.5 rounded bg-primary-500/10 text-primary-500 text-[10px] font-medium">
                    {article.category}
                  </span>
                  {article.hot && (
                    <span className="text-accent-500 text-xs">
                      <i className="ri-fire-line" />
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" /> {(article.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}